import { getPatient, registerPatient, getPrograms, getPatientByCpf, getPatientByRg } from '@bforms-web/common';

import PatientRegister, { PatientRegisterProps } from '../../components/Patient/Register';

const dispatchers: PatientRegisterProps = {
  getPatient,
  registerPatient,
  getPrograms,
  getPatientByCpf,
  getPatientByRg,
};

export default function PatientRegisterComposer(): JSX.Element {
  return <PatientRegister {...dispatchers} />;
}
